<bn-stepper [steps]="steps" (currentStepChange)="currentStepChange($event)">
</bn-stepper>